module.exports = __webpack_public_path__ + "static/img/loading.d21a73d4.gif";